// Generated using typescript-generator version null on 2019-05-27 11:11:50.

import { NeqHttpClient as HttpClient } from './http-client.config';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { URN } from '@sharedcommon/model/urn.model';
import { SharedPagedRequest } from '@sharedcommon/model/shared-page-request.model';
import { SharedPagedResponse } from '@sharedcommon/model/shared-paged-response.model';
import { environment } from '@sharedenvironment';

export class TechnicalMetaDto {
  key?: string;
  value?: string;
}

export class AbstractAuditableDto {
  modifiedBy?: string;
  modificationDate?: any;
}

export class ClassDto extends AbstractAuditableDto {
  id?: string;
  code?: string;
  label?: string;
  meta: boolean;
  sort?: number;
  listVariableClasses?: ClassVariableDto[];
  placementBeforeClass?: boolean;
  classPlacement?: ClassVariableDto;
}

export class ClassFilterDto extends SharedPagedRequest {
  label?: string;
  code?: string;
  meta?: boolean;
}

export class HttpEntity<T> {
  headers?: { [index: string]: any };
  body?: T;
}

export class ResponseEntity<T> extends HttpEntity<T> {
  statusCodeValue?: number;
  statusCode?: HttpStatus;
}

export class PatchClassesDto {
  orderedClassesCode?: string[];
  listPatchForClass?: PatchClassDto[];
}

export class DomainTranslateDto {
  codeLang?: string;
  labelLang?: string;
  elementTranslateLabel?: string;
  elementTranslateDescription?: string;
}

export class ClassVariableFilterDto extends SharedPagedRequest {
  code?: string;
  name?: string;
}

export class TranslateDto {
  id: string;
  lang?: string;
  translation?: string;
  field?: string;
}

export class TranslateClassVariableFilterDto extends SharedPagedRequest {
  code?: string;
  name?: string;
  langModel?: string;
  toTranslateLang: string;
  toTranslateLabelEmpty?: boolean;
}

export class DomainRightFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  hasRightForEntity?: boolean;
  hasRightForEntityModel?: boolean;
  entityModelCode?: string;
  entityCode?: string;
}

export class MatrixFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  entityCode?: string;
}

export class CalculateRequestDto {
  facetType?: string;
  facetValueBegin?: string;
  otherFacetsValues?: { [index: string]: string };
  variablesValues?: { [index: string]: string };
  variablesConditionValues?: { [index: string]: string };
  otherFacetsOptionals?: { [index: string]: boolean };
}

export class CalculateResponseDto {
  status?: Status;
  report?: string;
  details?: CalculateResponseDetailDto[];
}

export class EquationDto extends AbstractAuditableDto {
  id?: string;
  condition?: string;
  formula?: string;
  notes?: string;
  matrices?: string[];
  published?: boolean;
  facets?: EquationFacetDto[];
}

export class EquationFacetDto extends AbstractAuditableDto {
  type?: string;
  valueUrn?: URN;
  sort?: number;
  value?: string;
}

export class EquationFilterDto extends SharedPagedRequest {
  facetValues?: string[];
  facetType?: string;
  facetValue?: string;
  matrixCode?: string;
  published?: boolean;
  /** The calculated nutrient code to look for in capped version in all Equation a formula */
  calcCappedNutrientCode?: string ;
}

export class PrepareResultDto {
  variablesRequired?: string[];
  variablesConditionRequired?: string[];
  facets?: string[];
  otherFacets?: string[];
  facetsEquations?: { [index: string]: FacetEquationsDto };
}

export class MatrixDto extends AbstractAuditableDto {
  id?: string;
  code?: string;
  label?: string;
}

export class EntityRightFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
}

export class VariableDto extends AbstractAuditableDto {
  id?: string;
  sort?: number;
  code?: string;
  label?: string;
  conditionVariable?: boolean;
  defaultValue?: string;
  possibleValues?: string[];
  min?: number;
  max?: number;
  unit?: string;
  notes?: string;
  classVariable?: ClassVariableDto;
  placementBefore?: boolean;
  variablePlacement?: VariableDto;
}

export class VariableFilterDto extends SharedPagedRequest {
  codes?: string[];
  code?: string;
  label?: string;
  conditionVariable?: boolean;
  defaultValue?: string;
  minValue?: number;
  maxValue?: number;
  unit?: string;
  classId?: string;
  classCode?: string;
}

export class TranslateVariableFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  langModel?: string;
  toTranslateLang: string;
  classVariable?: string;
  toTranslateLabelEmpty?: boolean;
}

export class ClassVariableDto extends AbstractAuditableDto {
  id?: string;
  sort?: number;
  code?: string;
  label?: string;
}

export class PatchClassDto {
  classCode?: string;
  orderedVariablesCode?: string[];
}

export class TranslateClassVariableDto {
  id?: string;
  code?: string;
  name?: string;
  modelLabel?: string;
  toTranslateLabel?: string;
}

export class DomainRightDto {
  idDomain?: string;
  code?: string;
  label?: string;
  hasRightForEntity?: boolean;
  hasRightForEntityModel?: boolean;
}

export class CalculateResponseDetailDto {
  nutrientCode?: string;
  matrixCode?: string;
  value?: number;
  standard?: boolean;
}

export class PatchDto<T> {
  op?: PatchOperation;
  path?: string;
  value?: T;
  from?: string;
}

export class FacetEquationsDto {
  facetValue?: string;
  equations?: { [index: string]: SortedEquationDto };
  dependencies?: string[];
  computeOrder?: number;
}

export class EntityRightDto {
  elementId?: string;
  entity?: URN;
  entityLabel?: string;
  hasRight?: boolean;
}

export class TranslateVariableDto {
  id?: string;
  code?: string;
  label?: string;
  classVariableId?: string;
  classVariableCode?: string;
  classVariableLabel?: string;
  modelLabel?: string;
  toTranslateLabel?: string;
}

export class SortedEquationDto {
  equation?: EquationDto;
  sort?: number;
}

@Injectable()
export class TechnicalServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /technical/metas/{key}
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getMeta
   */
  getMeta(key: string): RestResponse<TechnicalMetaDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/metas/${key}` });
  }

  /**
   * HTTP GET /technical/rights
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getRights
   */
  getRights(): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/rights` });
  }
}

@Injectable()
export class ClassServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create variable class or meta class
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /classes
   * Java method: com.neovia.services.equation.service.ClassService.create
   */
  create(arg0: ClassDto): RestResponse<ClassDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`classes`, data: arg0 });
  }

  /**
   * Delete class
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP DELETE /classes/{id}
   * Java method: com.neovia.services.equation.service.ClassService.delete
   */
  delete(id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`classes/${id}` });
  }

  /**
   * Delete mzr  class
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP DELETE /classes/meta/{id}
   * Java method: com.neovia.services.equation.service.ClassService.deleteMetaClass
   */
  deleteMetaClass(id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`classes/meta/${id}` });
  }

  /**
   * Get all classes (meta + class)
   * Response code 200 - Partial ranged classes
   * Response code 404 - Not found
   * HTTP GET /classes
   * Java method: com.neovia.services.equation.service.ClassService.fetch
   */
  fetch(arg0: ClassFilterDto): RestResponse<SharedPagedResponse<ClassDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`classes`, data: arg0 });
  }

  /**
   * Get class or meta by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /classes/{id}
   * Java method: com.neovia.services.equation.service.ClassService.get
   */
  get(id: string): RestResponse<ClassDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`classes/${id}` });
  }

  /**
   * Update class or meta class
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /classes
   * Java method: com.neovia.services.equation.service.ClassService.put
   */
  put(arg0: ClassDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`classes`, data: arg0 });
  }

  /**
   * Patch class and variables order
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PUT /classes/order
   * Java method: com.neovia.services.equation.service.ClassService.updateOrder
   */
  updateOrder(arg0: PatchClassesDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`classes/order`, data: arg0 });
  }
}

@Injectable()
export class ClassVariableServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create class variable translate
   * Response code 204 - Created
   * Response code 500 - Error
   * HTTP POST /class-variables/{classVariableId}/translates
   * Java method: com.neovia.services.equation.service.SubClassVariableDomainTranslateService.translatesCreate
   */
  translatesCreate(classVariableId: string, arg1: DomainTranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`class-variables/${classVariableId}/translates`, data: arg1 });
  }

  /**
   * Get filtered & paged class variable translates
   * Response code 206 - Partial ranged class variable translates
   * Response code 404 - Not found
   * HTTP GET /class-variables/{classVariableId}/translates
   * Java method: com.neovia.services.equation.service.SubClassVariableDomainTranslateService.translatesFetch
   */
  translatesFetch(classVariableId: string): RestResponse<DomainTranslateDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`class-variables/${classVariableId}/translates` });
  }

  /**
   * Get all classes variables
   * Response code 200 - Partial ranged classes
   * Response code 404 - Not found
   * HTTP GET /class-variables
   * Java method: com.neovia.services.equation.service.ClassVariableService.fetch
   */
  fetch(arg0: ClassVariableFilterDto): RestResponse<SharedPagedResponse<ClassVariableDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`class-variables`, data: arg0 });
  }
}

@Injectable()
export class ClassVariableTranslateServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create (or update) class variable translate
   * Response code 204 - Created
   * Response code 500 - Error
   * HTTP POST /class_variable_translates
   * Java method: com.neovia.services.equation.service.ClassVariableTranslateService.create
   */
  create(arg0: TranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`class_variable_translates`, data: arg0 });
  }

  /**
   * Get filtered & paged class variable translates
   * Response code 206 - Partial ranged class variable translates
   * Response code 404 - Not found
   * HTTP GET /class_variable_translates
   * Java method: com.neovia.services.equation.service.ClassVariableTranslateService.fetch
   */
  fetch(arg0: TranslateClassVariableFilterDto): RestResponse<SharedPagedResponse<TranslateClassVariableDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`class_variable_translates`, data: arg0 });
  }
}

@Injectable()
export class DomainRightMatrixServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get filtered & paged matrix rights by entity
   * Response code 206 - Partial ranged matrix rights by entity
   * Response code 404 - Not found
   * HTTP GET /rights/matrices
   * Java method: com.neovia.services.equation.service.DomainRightMatrixService.fetch
   */
  fetch(arg0: DomainRightFilterDto): RestResponse<SharedPagedResponse<DomainRightDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`rights/matrices`, data: arg0 });
  }
}

@Injectable()
export class EntityServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Delete entity rights
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /entities/{entityCode}/rights
   * Java method: com.neovia.services.equation.service.EntityService.rightsDeleteEntityRights
   */
  rightsDeleteEntityRights(entityCode: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/rights` });
  }

  /**
   * Get filtered & paged matrices
   * Response code 206 - Partial ranged matrices
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/matrices
   * Java method: com.neovia.services.equation.service.SubMatrixService.matricesFetch
   */
  matricesFetch(entityCode: string, arg0: MatrixFilterDto): RestResponse<MatrixDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/matrices`, data: arg0 });
  }
}

@Injectable()
export class EquationServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP POST /equations/calculate
   * Java method: com.neovia.services.equation.service.EquationService.calculate
   */
  calculate(arg0: CalculateRequestDto): RestResponse<CalculateResponseDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`equations/calculate`, data: arg0 });
  }

  /**
   * HTTP POST /equations/calculate/entry
   * Java method: com.neovia.services.equation.service.EquationService.calculateEntry
   */
  calculateEntry(arg0: CalculateRequestDto, queryParams?: { facets?: string[]; }): RestResponse<CalculateResponseDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`equations/calculate/entry`, queryParams: queryParams, data: arg0 });
  }

  /**
   * Create equation
   * Response code 201 - Created
   * Response code 409 - Conflict
   * Response code 500 - Error
   * HTTP POST /equations
   * Java method: com.neovia.services.equation.service.EquationService.create
   */
  create(arg0: EquationDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`equations`, data: arg0 });
  }

  /**
   * Delete nutrient equation
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /equations/{id}
   * Java method: com.neovia.services.equation.service.EquationService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`equations/${id}` });
  }

  /**
   * Delete equations of a facet, check if facet is not used in a formula of other facets
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /equations/facets
   * Java method: com.neovia.services.equation.service.EquationService.deleteFacet
   */
  deleteFacet(queryParams?: { facet?: string; type?: string; }): RestResponse<EquationFacetDto> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`equations/facets`, queryParams: queryParams });
  }

  /**
   * Get filtered & paged equations
   * Response code 206 - Partial ranged equations
   * Response code 404 - Not found
   * HTTP GET /equations
   * Java method: com.neovia.services.equation.service.EquationService.fetch
   */
  fetch(arg0: EquationFilterDto): RestResponse<SharedPagedResponse<EquationDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`equations`, data: arg0 });
  }

  /**
   * Get equation by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /equations/{id}
   * Java method: com.neovia.services.equation.service.EquationService.get
   */
  get(id: string): RestResponse<EquationDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`equations/${id}` });
  }

  /**
   * Modify Equation
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PATCH /equations/{id}
   * Java method: com.neovia.services.equation.service.EquationService.patch
   */
  patch(id: string, arg3: PatchDto<string>[], queryParams?: { facetType?: string; facetValue?: string; }): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`equations/${id}`, queryParams: queryParams, data: arg3 });
  }

  /**
   * Modify facet code
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PATCH /equations
   * Java method: com.neovia.services.equation.service.EquationService.patchFacet
   */
  patchFacet(arg2: PatchDto<string>[], queryParams?: { oldFacetCode?: string; calculated?: boolean; }): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`equations`, queryParams: queryParams, data: arg2 });
  }

  /**
   * HTTP GET /equations/prepare
   * Java method: com.neovia.services.equation.service.EquationService.prepare
   */
  prepare(queryParams?: { facetValueBegin?: string; }): RestResponse<PrepareResultDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`equations/prepare`, queryParams: queryParams });
  }

  /**
   * HTTP GET /equations/prepare/entry
   * Java method: com.neovia.services.equation.service.EquationService.prepareEntry
   */
  prepareEntry(queryParams?: { facets?: string[]; facetValueBegin?: string; }): RestResponse<PrepareResultDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`equations/prepare/entry`, queryParams: queryParams });
  }

  /**
   * Update equation
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /equations
   * Java method: com.neovia.services.equation.service.EquationService.put
   */
  put(arg0: EquationDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`equations`, data: arg0 });
  }
}

@Injectable()
export class MatrixServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create matrix
   * Response code 201 - Created
   * Response code 409 - Conflict
   * Response code 500 - Error
   * HTTP POST /matrices
   * Java method: com.neovia.services.equation.service.MatrixService.create
   */
  create(arg0: MatrixDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`matrices`, data: arg0 });
  }

  /**
   * Delete matrix
   * Response code 202 - Deleted
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP DELETE /matrices/{id}
   * Java method: com.neovia.services.equation.service.MatrixService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`matrices/${id}` });
  }

  /**
   * Get filtered & paged matrices
   * Response code 206 - Partial ranged matrices
   * Response code 404 - Not found
   * HTTP GET /matrices
   * Java method: com.neovia.services.equation.service.MatrixService.fetch
   */
  fetch(arg0: MatrixFilterDto): RestResponse<SharedPagedResponse<MatrixDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`matrices`, data: arg0 });
  }

  /**
   * Get matrix by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /matrices/{id}
   * Java method: com.neovia.services.equation.service.MatrixService.get
   */
  get(id: string): RestResponse<MatrixDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`matrices/${id}` });
  }

  /**
   * Get matrix by code
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /matrices/code/{code}
   * Java method: com.neovia.services.equation.service.MatrixService.getByCode
   */
  getByCode(code: string): RestResponse<MatrixDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`matrices/code/${code}` });
  }

  /**
   * Create matrix right
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /matrices/{matrix_id}/rights
   * Java method: com.neovia.services.equation.service.SubMatrixRightService.rightsCreate
   */
  rightsCreate(matrix_id: string, queryParams?: { entityCode?: string; }): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`matrices/${matrix_id}/rights`, queryParams: queryParams });
  }

  /**
   * Delete matrix right
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /matrices/{matrix_id}/rights/{entity_code}
   * Java method: com.neovia.services.equation.service.SubMatrixRightService.rightsDelete
   */
  rightsDelete(matrix_id: string, entity_code: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`matrices/${matrix_id}/rights/${entity_code}` });
  }

  /**
   * Get matrix rights by entities
   * Response code 206 - Partial ranged entity rights
   * Response code 404 - Not found
   * HTTP GET /matrices/{matrix_id}/rights
   * Java method: com.neovia.services.equation.service.SubMatrixRightService.rightsFetch
   */
  rightsFetch(matrix_id: string, arg1: EntityRightFilterDto): RestResponse<SharedPagedResponse<EntityRightDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`matrices/${matrix_id}/rights`, data: arg1 });
  }

  /**
   * Update matrix
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PUT /matrices/{id}
   * Java method: com.neovia.services.equation.service.MatrixService.update
   */
  update(id: string, arg1: MatrixDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`matrices/${id}`, data: arg1 });
  }
}

@Injectable()
export class VariableServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create variable
   * Response code 201 - Created
   * Response code 409 - Conflict
   * Response code 500 - Error
   * HTTP POST /variables
   * Java method: com.neovia.services.equation.service.VariableService.create
   */
  create(arg0: VariableDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`variables`, data: arg0 });
  }

  /**
   * Delete variable
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /variables/{id}
   * Java method: com.neovia.services.equation.service.VariableService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`variables/${id}` });
  }

  /**
   * Delete variable value
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /variables/{id}/values/{value}
   * Java method: com.neovia.services.equation.service.VariableService.valuesDeletePossibleValues
   */
  valuesDeletePossibleValues(id: string, value: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`variables/${id}/values/${value}` });
  }

  /**
   * Create variable translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP POST /variables/{variableId}/translates
   * Java method: com.neovia.services.equation.service.SubVariableDomainTranslateService.translatesCreate
   */
  translatesCreate(variableId: string, arg0: DomainTranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`variables/${variableId}/translates`, data: arg0 });
  }

  /**
   * Get filtered & paged variable translates
   * Response code 206 - Partial ranged variable translates
   * Response code 404 - Not found
   * HTTP GET /variables/{variableId}/translates
   * Java method: com.neovia.services.equation.service.SubVariableDomainTranslateService.translatesFetch
   */
  translatesFetch(variableId: string): RestResponse<DomainTranslateDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`variables/${variableId}/translates` });
  }

  /**
   * Get filtered & paged variables
   * Response code 206 - Partial ranged variables
   * Response code 404 - Not found
   * HTTP GET /variables
   * Java method: com.neovia.services.equation.service.VariableService.fetch
   */
  fetch(arg0: VariableFilterDto): RestResponse<SharedPagedResponse<VariableDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`variables`, data: arg0 });
  }

  /**
   * Get variable by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /variables/{id}
   * Java method: com.neovia.services.equation.service.VariableService.get
   */
  get(id: string): RestResponse<VariableDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`variables/${id}` });
  }

  /**
   * Get variable by code
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /variables/code/{code}
   * Java method: com.neovia.services.equation.service.VariableService.getByCode
   */
  getByCode(code: string): RestResponse<VariableDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`variables/code/${code}` });
  }

  /**
   * Patch variable (available values)
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PATCH /variables/{id}
   * Java method: com.neovia.services.equation.service.VariableService.patch
   */
  patch(id: string, arg1: PatchDto<string[]>[]): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`variables/${id}`, data: arg1 });
  }

  /**
   * Update variable
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PUT /variables/{id}
   * Java method: com.neovia.services.equation.service.VariableService.update
   */
  update(id: string, arg1: VariableDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`variables/${id}`, data: arg1 });
  }
}

@Injectable()
export class VariableTranslateServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create variable translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP POST /variable_translates
   * Java method: com.neovia.services.equation.service.VariableTranslateService.create
   */
  create(arg0: TranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`variable_translates`, data: arg0 });
  }

  /**
   * Get filtered & paged variable translates
   * Response code 206 - Partial ranged variable translates
   * Response code 404 - Not found
   * HTTP GET /variable_translates
   * Java method: com.neovia.services.equation.service.VariableTranslateService.fetch
   */
  fetch(arg0: TranslateVariableFilterDto): RestResponse<SharedPagedResponse<TranslateVariableDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`variable_translates`, data: arg0 });
  }
}

export type RestResponse<R> = Observable<R>;

export type TextMatchMode = 'STRICT' | 'CONTAINS';

export type HttpStatus = 'CONTINUE' | 'SWITCHING_PROTOCOLS' | 'PROCESSING' | 'CHECKPOINT' | 'OK' | 'CREATED' | 'ACCEPTED' | 'NON_AUTHORITATIVE_INFORMATION' | 'NO_CONTENT' | 'RESET_CONTENT' | 'PARTIAL_CONTENT' | 'MULTI_STATUS' | 'ALREADY_REPORTED' | 'IM_USED' | 'MULTIPLE_CHOICES' | 'MOVED_PERMANENTLY' | 'FOUND' | 'MOVED_TEMPORARILY' | 'SEE_OTHER' | 'NOT_MODIFIED' | 'USE_PROXY' | 'TEMPORARY_REDIRECT' | 'PERMANENT_REDIRECT' | 'BAD_REQUEST' | 'UNAUTHORIZED' | 'PAYMENT_REQUIRED' | 'FORBIDDEN' | 'NOT_FOUND' | 'METHOD_NOT_ALLOWED' | 'NOT_ACCEPTABLE' | 'PROXY_AUTHENTICATION_REQUIRED' | 'REQUEST_TIMEOUT' | 'CONFLICT' | 'GONE' | 'LENGTH_REQUIRED' | 'PRECONDITION_FAILED' | 'PAYLOAD_TOO_LARGE' | 'REQUEST_ENTITY_TOO_LARGE' | 'URI_TOO_LONG' | 'REQUEST_URI_TOO_LONG' | 'UNSUPPORTED_MEDIA_TYPE' | 'REQUESTED_RANGE_NOT_SATISFIABLE' | 'EXPECTATION_FAILED' | 'I_AM_A_TEAPOT' | 'INSUFFICIENT_SPACE_ON_RESOURCE' | 'METHOD_FAILURE' | 'DESTINATION_LOCKED' | 'UNPROCESSABLE_ENTITY' | 'LOCKED' | 'FAILED_DEPENDENCY' | 'UPGRADE_REQUIRED' | 'PRECONDITION_REQUIRED' | 'TOO_MANY_REQUESTS' | 'REQUEST_HEADER_FIELDS_TOO_LARGE' | 'UNAVAILABLE_FOR_LEGAL_REASONS' | 'INTERNAL_SERVER_ERROR' | 'NOT_IMPLEMENTED' | 'BAD_GATEWAY' | 'SERVICE_UNAVAILABLE' | 'GATEWAY_TIMEOUT' | 'HTTP_VERSION_NOT_SUPPORTED' | 'VARIANT_ALSO_NEGOTIATES' | 'INSUFFICIENT_STORAGE' | 'LOOP_DETECTED' | 'BANDWIDTH_LIMIT_EXCEEDED' | 'NOT_EXTENDED' | 'NETWORK_AUTHENTICATION_REQUIRED';

export type Status = 'STARTED' | 'FAILED' | 'FINISHED' | 'SAVED' | 'UNPROCESSED';

export type PatchOperation = 'ADD' | 'REMOVE' | 'REPLACE' | 'COPY' | 'MOVE' | 'TEST';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = environment.equation.baseUrl;
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}
